var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViguetasT21(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1305.87 1132.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4d4c4c;}.cls-2{fill:#b8b8b7;}.cls-3{clip-path:url(#clippath-2);}.cls-4{fill:#cfcfcf;}.cls-5{fill:none;}.cls-6{fill:#009ee2;}.cls-7{fill:#9c9b9b;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 568.1,
    cy: 592.38,
    r: 457.67
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 568.1,
    cy: 592.38,
    r: 457.67
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 52.38,
    width: 1080,
    height: 1080
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 568.1,
    cy: 592.38,
    r: 457.67
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "182.09 758.51 83.22 747.77 55.28 709.24 183.7 638.15 182.09 758.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "244.95 596.58 1233.1 54.33 1103.97 0 139.89 527.09 244.95 596.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "320.99 862.92 1305.87 321.3 1213.18 224.32 215.78 764.36 320.99 862.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "315.52 979.3 1295.07 442.91 1302.06 318.76 321.23 857.68 315.52 979.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "215.78 770.56 1213.18 224.32 1232.94 54.42 245.15 593.95 215.78 770.56"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M246.88,592.99c-.88,10.89-3.97,36.49-3.97,36.49l-15.88,134s62.65,59.05,95.13,92.43l-6.64,123.39L54.23,818.5l1.05-109.26,88.06,19.14-3.15-136.97-.29-64.32,106.99,65.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.22,894.59c-.13,4.29,2.84,9.01,6.65,10.54,3.82,1.54,7.05-.7,7.18-5.02,.14-4.33-2.87-9.07-6.7-10.58-3.82-1.51-7,.77-7.13,5.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.02,833.52c-.06,4.1,2.63,8.49,6.04,9.82,3.42,1.34,6.26-.92,6.33-5.04,.07-4.13-2.66-8.55-6.08-9.86-3.41-1.3-6.22,.97-6.29,5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.04,787.53c-.02,3.93,2.46,8.06,5.54,9.24,3.09,1.18,5.62-1.05,5.65-5.01,.02-3.96-2.48-8.11-5.58-9.27-3.09-1.15-5.59,1.1-5.61,5.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.82,619.53c-.07,4.36,2.73,8.66,6.27,9.59,3.56,.94,6.52-1.85,6.6-6.25,.08-4.4-2.75-8.71-6.32-9.62-3.55-.91-6.48,1.91-6.56,6.28Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "182.09 758.51 83.22 747.77 55.28 709.24 183.7 638.15 182.09 758.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "574.44 289.51 139.89 527.09 244.95 596.58 574.44 415.77 574.44 289.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "574.44 570.17 215.78 764.36 320.99 862.92 574.44 723.54 574.44 570.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "574.44 718.56 321.23 857.68 315.52 979.3 574.44 837.52 574.44 718.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "574.44 414.1 245.15 593.95 215.78 770.56 574.44 574.14 574.44 414.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M246.88,592.99c-.88,10.89-3.97,36.49-3.97,36.49l-15.88,134s62.65,59.05,95.13,92.43l-6.64,123.39L54.23,818.5l1.05-109.26,88.06,19.14-3.15-136.97-.29-64.32,106.99,65.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.22,894.59c-.13,4.29,2.84,9.01,6.65,10.54,3.82,1.54,7.05-.7,7.18-5.02,.14-4.33-2.87-9.07-6.7-10.58-3.82-1.51-7,.77-7.13,5.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.02,833.52c-.06,4.1,2.63,8.49,6.04,9.82,3.42,1.34,6.26-.92,6.33-5.04,.07-4.13-2.66-8.55-6.08-9.86-3.41-1.3-6.22,.97-6.29,5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.04,787.53c-.02,3.93,2.46,8.06,5.54,9.24,3.09,1.18,5.62-1.05,5.65-5.01,.02-3.96-2.48-8.11-5.58-9.27-3.09-1.15-5.59,1.1-5.61,5.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.82,619.53c-.07,4.36,2.73,8.66,6.27,9.59,3.56,.94,6.52-1.85,6.6-6.25,.08-4.4-2.75-8.71-6.32-9.62-3.55-.91-6.48,1.91-6.56,6.28Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViguetasT21);
export default __webpack_public_path__ + "static/media/Viguetas T21.6f2b6c585a1d8c4ca5a8f9df85ffd7ad.svg";
export { ForwardRef as ReactComponent };